import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../models/DataFunctions.js";
import addLogDocument from "./addLogDocument.js"; // Assuming a custom log function similar to FlutterFlow

// Function to remove an operator
const removeOperator = async (operatorId, folderId, token, prefix) => {
  // Define the endpoint URL
  const url = prefix + "actions/remove-operator";

  // Define the request body
  const body = {
    operator_id: operatorId,
    folder_id: folderId,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");

    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "", // Any other optional fields
      "",
      JSON.stringify(body), // The request body as a string
      await response.text() // Response body as text
    );

    // Check if the request was successful
    if (response.ok) {
      return "Operator removed successfully";
    } else {
      // Handle error response
      return `Failed to remove operator: ${response.status}`;
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return `Exception occurred: ${error.message}`;
  }
};

export default removeOperator;
